import { styled } from '@chilipiper/design-system'

export const StyledNormalizedField = styled.textarea`
  border: none;
  background-color: transparent;
  resize: none;
  outline: none;
  height: 40px;
  padding: 0px;
  line-height: 35px;
  overflow: hidden;
  flex: 1;
`
